import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles, createStyleSheet} from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import {ListItem, ListItemIcon, ListItemText} from 'material-ui/List';

import MenuIcon from 'material-ui-icons/Menu';
import LanguageIcon from 'material-ui-icons/Language';
import NoteIcon from 'material-ui-icons/Note';
import AnnouncementIcon from 'material-ui-icons/Announcement'
import AccountBalanceIcon from 'material-ui-icons/AccountBalance'
import TranslateIcon from 'material-ui-icons/Translate'
import InsertLink from 'material-ui-icons/InsertLink'
import Copyright from 'material-ui-icons/Copyright'
import {BrowserRouter, Route, Link} from 'react-router-dom'

import Portuguese from './portuguese'
import Introduction from './introduction'
import Abbreviations from './abbreviations'
import Policy from './policy'
import Citations from './citations'
import Credits from './credits'
import CardinalForm from './formCardinal'
import OrdinalForm from './formOrdinal'
import FractionForm from './formFraction'
import SocialShare from './social-share'
import logo from './img/logo_NaDuvida_logo_310x70.png'


const search = (word) => {
    return(
        <Portuguese searchWord={word.match.params.word}/>
    )
}

const styleSheet = createStyleSheet('DrawerMenu', {
    list: {

        backgroundColor: '#F3D72C',
    },
    menu: {
        cursor: 'pointer',
        borderRadius: '0%',
        color: 'white',
    },
    navbar: {
        width: '100%',
        flex: 1,
    },
    content: {
        marginTop: 100,
    },
});

const routes = [

    {
        path: '/',
        call: Portuguese,
        bar: 'Dicionário',
        header: () => <p>Dicionário</p>,
        menu: true,
        icon: <LanguageIcon/>
    },
    {
        path: '/mini-dicionário/introdução/',
        call: Introduction,
        bar: 'Introdução',
        header: () => <p>Introdução</p>,
        menu: true,
        icon: <NoteIcon/>
    },
    {
        path: '/mini-dicionário/abreviaturas/',
        call: Abbreviations,
        bar: 'Abreviaturas',
        header: () => <p>Abreviaturas</p>,
        menu: true,
        icon: <AnnouncementIcon/>
    },
    {
        path: '/mini-dicionário/política-de-uso/',
        call: Policy,
        bar: 'Política de uso',
        header: () => <p>Política de uso</p>,
        menu: true,
        icon: <AccountBalanceIcon/>
    },
    {
        path: '/mini-dicionário/cardinais/',
        call: CardinalForm,
        bar: 'Calcular cardinal de um número',
        header: () => <p>Calcular cardinal de um número</p>,
        menu: true,
        icon: <TranslateIcon/>
    },
    {
        path: '/mini-dicionário/ordinais/',
        call: OrdinalForm,
        bar: 'Calcular ordinal de um número',
        header: () => <p>Calcular ordianal de um número</p>,
        menu: true,
        icon: <TranslateIcon/>
    },
    {
        path: '/mini-dicionário/frácionarios/',
        call: FractionForm,
        bar: 'Calculadora de fracionários',
        header: () => <p>Calcular fracionários de uma fração</p>,
        menu: true,
        icon: <TranslateIcon/>
    },
    {
        path: '/mini-dicionário/citar/',
        call: Citations,
        bar: 'Como citar',
        header: () => <p>Como citar NaDúvida</p>,
        menu: true,
        icon: <InsertLink/>
    },
    {
        path: '/mini-dicionário/creditos/',
        call: Credits,
        bar: 'Créditos ao autores',
        header: () => <p>Crédito aos autores</p>,
        menu: true,
        icon: <Copyright/>
    },
    {
        path: '/:word',
        call: search,
        bar: 'Dicionário',
        header: () => <p></p>,
        menu: false,
        icon: <LanguageIcon/>
    },

];


class DrawerMenu extends Component {
    state = {
        open: false
    };

    toggleDrawer = (open) => {
        this.setState({open: open});
    };

    handleLeftOpen = () => this.toggleDrawer(true);
    handleLeftClose = () => this.toggleDrawer(false);


    render() {
        const classes = this.props.classes;

        return (
            <div>
                <BrowserRouter>
                    <div>
                        <AppBar position="fixed">
                            <Toolbar className={classes.navbar}>
                                <IconButton className={classes.menu} onClick={this.handleLeftOpen}>
                                    <MenuIcon/>
                                </IconButton>

                                <Typography type="title">
                                    {routes.map((route, index) => (
                                        <Route
                                            key={index}
                                            path={route.path}
                                            exact={true}
                                            component={route.header}
                                        />
                                    ))}
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <Drawer open={this.state.open}
                                onRequestClose={this.handleLeftClose}
                                onClick={this.handleLeftClose}
                        >

                            <img src={logo} width="310" alt="logo de Naduvida" title="logo de Naduvida"/>

                            {routes.filter(route => route.menu)
                                .map((route, index) => (
                                    <ListItem button key={index} className={classes.list}>
                                        <ListItemIcon>
                                            {route.icon}
                                        </ListItemIcon>
                                        <Link to={route.path}><ListItemText primary={route.bar}/></Link>
                                    </ListItem>
                                ))}
                        </Drawer>

                        <div className={classes.content}>

                            {routes.map((route, index) => (
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={true}
                                    component={route.call}
                                />
                            ))}
                            <SocialShare/>
                        </div>

                    </div>
                </BrowserRouter>

            </div>
        )
    }
}

DrawerMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(DrawerMenu);



// WEBPACK FOOTER //
// ./src/drawermenu.jsx